import { AudioComponent } from "@educaplay/core"
import styles from "./AudioCard.module.scss"
import clsx from "clsx"

export function AudioCard({ sourceAudio, className, isSelected, isCorrect}) {
    return <div className={clsx(styles.cardAudioContainer, className)} >
        <AudioComponent source={sourceAudio} className={clsx(styles.audioOverride, isCorrect&&styles.audioCorrect)} autoplay={isSelected}/>
    </div>
}